export const getPreviewSettingsFromSearchParams = (searchParams: URLSearchParams) => {
  const withTimer = getBooleanParam(searchParams, 'withTimer');
  const shouldSortByExamSettings = getBooleanParam(searchParams, 'shouldSortByExamSettings');
  const shouldDisplayAnswer = getBooleanParam(searchParams, 'shouldDisplayAnswer');

  if (!withTimer && !shouldSortByExamSettings && !shouldDisplayAnswer) {
    return undefined;
  }

  return {
    withTimer: withTimer ?? false,
    shouldSortByExamSettings: shouldSortByExamSettings ?? false,
    shouldDisplayAnswer: shouldDisplayAnswer ?? false,
  };
};

const getBooleanParam = (searchParams: URLSearchParams, param: string) => {
  const value = searchParams.get(param);
  if (!value) {
    return undefined;
  }

  return value === 'true';
};
